



















import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { Building, BuildingsApi, Property } from 'performo-api';
import { mapGetters } from 'vuex';

@Component({
  components: {},
  computed: mapGetters({
    currentProperty: 'currentProperty',
    currentPropertyId: 'currentPropertyId',
    buildingsApi: 'buildingsApi'
  })
})
export default class BuildingDisplayComponent extends Vue {
  @Prop({ required: false, default: 'Building' })
  private label!: string;

  @Prop({ required: true, type: String })
  private buildingCode!: string;

  private currentPropertyId!: string;

  private currentProperty!: Property;

  private buildingsApi!: BuildingsApi;

  building!: Building;

  data() {
    return {
      building: undefined
    };
  }

  private async created() {
    await this.hydrateStorage();
  }

  private mounted() {
    if (this.buildingCode) {
      this.loadBuildingDetails(this.buildingCode, 0);
    }
  }

  @Watch('buildingCode')
  buildingCodeWatcher(val: string) {
    this.loadBuildingDetails(val, 0);
  }

  loadBuildingDetails(val: string, count: number) {
    // check session storage first, and use that, otherwise load from db

    // check big building list
    const buildings = JSON.parse(
      sessionStorage.getItem(`buildings-${this.currentPropertyId}`) || '[]'
    ) as Building[];

    // retry
    if (count < 3 && buildings.length === 0) {
      setTimeout(() => this.loadBuildingDetails(val, count + 1), 200);
      return;
    }

    const bld = buildings.find((b) => b.buildingCode === val);

    // find and return
    if (bld && bld.buildingCode === val) {
      this.building = bld;
      return;
    }

    // do a one-off building query and try that
    this.buildingsApi
      .queryBuildings({ buildingCode: val })
      .then((buildings) => {
        if (buildings.length === 1) {
          this.building = buildings[0];
        }
      })
      .catch(() => {
        /**? */
      });
  }

  async hydrateStorage() {
    if (sessionStorage.getItem(`buildings-${this.currentPropertyId}`)) {
      // don't need to re-hydrate
      return;
    }
    sessionStorage.setItem(`buildings-${this.currentPropertyId}`, '[]');
    const buildings = await this.buildingsApi.queryBuildings({
      propertyId: this.currentPropertyId
    });
    sessionStorage.setItem(
      `buildings-${this.currentPropertyId}`,
      JSON.stringify(buildings)
    );
  }
}
